/**
 * Section 2: Property Access
 */

import { useCallback } from 'preact/hooks';
import { useForm } from '@ox/visits-ui/context/FormContext';
import { CheckboxList } from '@ox/blox';

const APPLIANCES = ['Microwave', 'Stove', 'Oven', 'Refrigerator', 'Washer', 'Dryer', 'Dishwasher'];
const APPLIANCES_REPLACEMENT = [
  'Microwave',
  'Stove',
  'Oven',
  'Dishwasher',
  'Refrigerator',
  'Washer',
  'Dryer',
  'Utilities are not on, unable to confirm if appliances are functioning.',
  'None or Unsure',
];

export function Section3Appliances() {
  const { formData, errors, updateField } = useForm();

  const handleCheckBoxListChange = useCallback(
    (e) => {
      if (e.target.checked === true) {
        updateField(e.target.name, [formData.installed_appliances, e.target.value].join(', '));
      } else {
        const newValues = (formData.installed_appliances || '').split(', ').filter((val) => val !== e.target.value);
        updateField(e.target.name, newValues.join(', '));
      }
    }, [updateField, formData.installed_appliances]
  );

  return (
    <div className="form-section">
      <h2>Appliances</h2>

      <CheckboxList
        label="Please list all appliances installed on the property"
        name="installed_appliances"
        options={APPLIANCES.map((appliance) => ({ label: appliance, value: appliance }))}
        onChange={handleCheckBoxListChange}
        defaultValue={(formData.installed_appliances || '').split(', ') || []}
        required
        errorMessage={errors.installed_appliances}
      />

      <CheckboxList
        label="Please indicate which, if ANY, appliances need replacement/repair"
        name="appliances_need_replacement"
        options={APPLIANCES_REPLACEMENT.map((appliance) => ({ label: appliance, value: appliance }))}
        onChange={handleCheckBoxListChange}
        defaultValue={(formData.appliances_need_replacement || '').split(', ') || []}
        required
        errorMessage={errors.appliances_need_replacement}
      />
    </div>
  );
}
